import { render, staticRenderFns } from "./StudentIndexColumn.vue?vue&type=template&id=44a42ef4&"
import script from "./StudentIndexColumn.vue?vue&type=script&lang=ts&"
export * from "./StudentIndexColumn.vue?vue&type=script&lang=ts&"
import style0 from "./StudentIndexColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports